module.exports = __webpack_public_path__ + "img/icon_wedding_banquet.65d611f8.png";